var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCancelIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4555_1550",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 18,
    height: 18
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4555_1550)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.35605 12.6L8.9998 9.9563L11.6436 12.6L12.5998 11.6438L9.95605 9.00005L12.5998 6.3563L11.6436 5.40005L8.9998 8.0438L6.35605 5.40005L5.3998 6.3563L8.04355 9.00005L5.3998 11.6438L6.35605 12.6ZM8.9998 16.2C8.0123 16.2 7.08105 16.0125 6.20605 15.6375C5.33105 15.2625 4.56543 14.7469 3.90918 14.0907C3.25293 13.4344 2.7373 12.6688 2.3623 11.7938C1.9873 10.9188 1.7998 9.98755 1.7998 9.00005C1.7998 8.00005 1.9873 7.06567 2.3623 6.19692C2.7373 5.32817 3.25293 4.56567 3.90918 3.90942C4.56543 3.25317 5.33105 2.73755 6.20605 2.36255C7.08105 1.98755 8.0123 1.80005 8.9998 1.80005C9.9998 1.80005 10.9342 1.98755 11.8029 2.36255C12.6717 2.73755 13.4342 3.25317 14.0904 3.90942C14.7467 4.56567 15.2623 5.32817 15.6373 6.19692C16.0123 7.06567 16.1998 8.00005 16.1998 9.00005C16.1998 9.98755 16.0123 10.9188 15.6373 11.7938C15.2623 12.6688 14.7467 13.4344 14.0904 14.0907C13.4342 14.7469 12.6717 15.2625 11.8029 15.6375C10.9342 16.0125 9.9998 16.2 8.9998 16.2Z",
    fill: "#999999"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancelIcon);
export default __webpack_public_path__ + "static/media/cancelIcon.0dfd657043dc85fae79243998869e7c0.svg";
export { ForwardRef as ReactComponent };